export default function Cachedfunction (data: any) {
  const ttlInSeconds = 3600

  const expirationTime = new Date().getTime() + ttlInSeconds * 1000;
  const item = { data, expirationTime };
  localStorage.setItem('MENU_COMMAND', JSON.stringify(item));
}
